import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const categories = [
  { key: 'shoes', icon: 'ri-footprint-line', desc: 'Explore a vast selection of sneakers, running shoes, and designer footwear.' },
  { key: 'hoodies', icon: 'ri-t-shirt-line', desc: 'Premium hoodies and sweaters for every style and season.' },
  { key: 'tshirts', icon: 'ri-t-shirt-2-line', desc: 'T-shirts from streetwear to luxury brands, all organized in one place.' },
  { key: 'jackets', icon: 'ri-shirt-line', desc: 'Jackets, coats, and outerwear for any weather condition.' },
  { key: 'pants', icon: 'ri-shirt-line', desc: 'Pants, shorts, and joggers with detailed sizing and QC information.' },
  { key: 'headwear', icon: 'ri-landscape-line', desc: 'Caps, beanies, and headwear from top brands.' },
  { key: 'sets', icon: 'ri-stack-line', desc: 'Matching sets and coordinated outfits for effortless style.' },
  { key: 'underwear', icon: 'ri-vip-diamond-line', desc: 'Quality underwear and underpants with size guides.' },
  { key: 'jersey', icon: 'ri-shirt-fill', desc: 'Sports jerseys and athletic wear for fans and athletes.' },
  { key: 'accessories', icon: 'ri-key-2-line', desc: 'Watches, jewelry, and fashion accessories.' },
  { key: 'bags', icon: 'ri-shopping-bag-3-line', desc: 'Backpacks, handbags, and travel bags.' },
  { key: 'belts', icon: 'ri-link', desc: 'Designer belts and functional accessories.' },
  { key: 'perfumes', icon: 'ri-drop-line', desc: 'Fragrances and perfumes from popular brands.' },
  { key: 'other', icon: 'ri-more-line', desc: 'Miscellaneous items and special finds.' },
];

export default function CategoriesPage() {
  const { t } = useTranslation();

  const handleCategoryClick = (key: string) => {
    const url = t(`cat_url_${key}`);
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <section className="pt-20 md:pt-24 pb-8 md:pb-12 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-2 mb-4">
              <a href="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1">
                <i className="ri-home-line w-3 h-3 flex items-center justify-center" /> Home
              </a>
              <span className="text-foreground-300">/</span>
              <span className="text-xs text-primary-600 font-medium">Categories</span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
              CSSBuy Spreadsheet <span className="text-primary-500">Categories</span>
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              Browse all product categories available in the CSSBuy Spreadsheet. Click any category to explore products on the main website.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {categories.map((cat) => (
                <button
                  key={cat.key}
                  onClick={() => handleCategoryClick(cat.key)}
                  className="group text-left bg-white rounded-xl p-6 border border-background-200 hover:border-primary-300 hover:shadow-md transition-all"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center shrink-0 group-hover:bg-primary-100 transition-colors">
                      <i className={`${cat.icon} w-6 h-6 flex items-center justify-center text-primary-500 text-xl`} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-semibold text-sm text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                        {t(`category_${cat.key}`)}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed mb-3">{cat.desc}</p>
                      <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                        Explore <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center" />
                      </span>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}